// Per-company-record status, used to build the (possibly multi-badge)
// status shown for a grouped user row.
function getStatusInfo(record) {
  if (record.verified === false) {
    return record.sent_at
      ? { key: "not_verified", label: "Not Verified" }
      : { key: "not_invited", label: "Not Invited" };
  }
  return record.active !== false
    ? { key: "active", label: "Active" }
    : { key: "inactive", label: "Inactive" };
}

export function groupUsers(users, companiesMap) {
  const groups = new Map();
  users.forEach((user) => {
    const email = user.email ? user.email.toLowerCase().trim() : null;
    const key = email || user.uuid;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(user);
  });

  return Array.from(groups.values()).map((group) => {
    const primaryName = {
      firstName: group[0].firstName,
      lastName: group[0].lastName,
    };
    const alsoKnownAs = group
      .slice(1)
      .filter(
        (u) =>
          u.firstName !== primaryName.firstName ||
          u.lastName !== primaryName.lastName
      )
      .map((u) => ({ firstName: u.firstName, lastName: u.lastName }));

    const companyUuids = group.map((u) => u.company_uuid).filter(Boolean);
    const companyNames = companyUuids.map(
      (uuid) => companiesMap[uuid] || uuid.slice(0, 8) + "\u2026"
    );

    // Earliest record wins, so a multi-company user shows when they first joined.
    const createdDates = group
      .map((u) => u.created_at ?? u.createdAt)
      .filter(Boolean)
      .sort();

    return {
      ...group[0],
      createdAt: createdDates[0] || null,
      uuids: group.map((u) => u.uuid),
      pendingInvite: group.some((u) => u.verified === false),
      // Distinguishes "never invited" (no invite email sent yet) from
      // "invited but hasn't verified/accepted yet" among unverified members.
      notInvited: group.some((u) => u.verified === false && !u.sent_at),
      // One status per company, in the same order as companyNames/companyUuids,
      // so a user who is e.g. active at one company and inactive at another
      // can be displayed accurately instead of collapsing to a single status.
      statuses: group.map(getStatusInfo),
      companyUuids,
      companyNames,
      alsoKnownAs,
    };
  });
}
